<template>
  <v-card
      v-if="!isEmpty(entity)"
      flat column>
    <v-subheader>
      Dados do Solicitante
    </v-subheader>
    <v-card
        flat
        class="ml-3 px-4 py-2"
        color="grey lighten-5">
      <v-layout column>
        <v-subheader class="px-0">
          <b>Dados do Solicitante</b>
        </v-subheader>

        <span>
          {{entity.name}}
        </span>
        <span>
          {{formatCpfCnpj(entity.cpf_cnpj)}}
        </span>
        <span>
          {{entity.address.street}},
          {{entity.address.number}},
          {{entity.address.complement}}
        </span>
        <span>
          {{entity.address.city.name}} - {{entity.address.federal_unit.name}}
        </span>
        <span>
                {{entity.address.zip_code}}
              </span>
        <v-subheader class="px-0">
          <b>Endereço do Empreendimento</b>
        </v-subheader>
        <span>
          {{applicationAddress.street}},
          {{applicationAddress.number}},
          {{applicationAddress.complement}}
        </span>
        <span>
          Coordenadas Geográficas (SIRGAS 2000): {{ applicationAddress.latitude }}, {{ applicationAddress.longitude }}
        </span>
        <span>
          {{applicationAddress.city.name}} - {{applicationAddress.federal_unit.name}}
        </span>
        <span>
          {{applicationAddress.zip_code}}
        </span>

      </v-layout>
    </v-card>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import formatCpfCnpj from "@/utils/formatCpfCnpj";
import { isEmpty } from 'lodash';

export default {
  name: 'ResumeEntity',
  data() {
    return {
      isEmpty,
      formatCpfCnpj
    }
  },
  computed: {
    ...mapGetters('newApplication', ['newApplication']),
    entity() {
      return this.newApplication.entity;
    },
    applicationAddress() {
      return this.newApplication.applicationAddress;
    }
  }
};
</script>
